export const decodeSavedHtml = (savedHtml: string): string => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = savedHtml;

  return textarea.value;
};
